import AppLinkContainer from './app-link-container';

export default AppLinkContainer;
